import Service from "@services/Service";
import { WEB_API_ENDPOINT } from "@utils/awsAmplify";

class Report extends Service {
  static generateEmbeddedUrl(quickSightID) {
    return Report.get(WEB_API_ENDPOINT, `/reports/${quickSightID}`);
  }
}

export default Report;
